import React from "react";
import { Link } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";

const ServiceCharterSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6 lg:px-8">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
              Our Service Charter
            </h2>
            <p className="text-xl text-gray-600 max-w-full mx-auto">
              At KARUMO TECHNICAL TRAINING INSTITUTE, we are committed to providing
              excellent service to our students, staff, and community. Our service
              charter outlines our standards, procedures, and commitments to quality
              education and support.
            </p>
          </div>

          {/* Content Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            {/* Left Column - Key Commitments */}
            <div className="space-y-8">
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center">
                    <Icon name="Clock" size={24} className="text-blue-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Timely Service Delivery
                    </h3>
                    <p className="text-gray-600">
                      We ensure prompt processing of applications, timely communication,
                      and efficient service delivery across all our operations.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center">
                    <Icon name="Shield" size={24} className="text-green-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Quality Assurance
                    </h3>
                    <p className="text-gray-600">
                      Our commitment to excellence ensures that all services meet
                      the highest standards of quality and professionalism.
                    </p>
                  </div>
                </div>

                <div className="flex items-start space-x-4">
                  <div className="flex-shrink-0 w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center">
                    <Icon name="Users" size={24} className="text-yellow-600" />
                  </div>
                  <div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-2">
                      Customer-Centric Approach
                    </h3>
                    <p className="text-gray-600">
                      We prioritize your needs and feedback, ensuring our services
                      are designed with you in mind.
                    </p>
                  </div>
                </div>
              </div>

              {/* CTA Button */}
              <div className="pt-4">
                <Link to="/resources?tab=service-charter">
                  <Button
                    variant="default"
                    size="lg"
                    iconName="ExternalLink"
                    iconPosition="right"
                    className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3"
                  >
                    View Full Service Charter
                  </Button>
                </Link>
              </div>
            </div>

            {/* Right Column - Multimedia Preview */}
            <div className="space-y-6">
              <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                <div className="flex items-center space-x-3 mb-4">
                  <Icon name="Video" size={24} className="text-blue-600" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    Service Charter Videos
                  </h3>
                </div>
                <p className="text-gray-600 mb-4">
                  Watch our informative videos that explain our service charter,
                  commitments, and how we strive to serve you better.
                </p>
                <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden">
                  <video
                    src="/assets/files/Video_English.mp4"
                    className="w-full h-full object-cover"
                    controls
                    preload="metadata"
                   
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
              </div>

              <div className="bg-gray-50 rounded-lg p-6 border border-gray-200">
                <div className="flex items-center space-x-3 mb-4">
                  <Icon name="FileText" size={24} className="text-blue-500" />
                  <h3 className="text-lg font-semibold text-gray-900">
                    Service Charter Documents
                  </h3>
                </div>
                <p className="text-gray-600 mb-4">
                  Access our comprehensive service charter documents in PDF format,
                  available in both English and Kiswahili.
                </p>
                <a
                  href="/assets/files/KARUMO_SERVICE_CHARTER.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-yellow-600 transition-colors"
                >
                  <Icon name="Download" size={16} className="mr-2" />
                  View Service Charter PDF
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceCharterSection;
